import React from "react";
import { useDebounce } from "../../hooks";

import "./search-bar.scss";

export const SearchBar = React.forwardRef(
  ({ onChange, placeholder, autoComplete, spellCheck, delay = 300, id, defaultValue }, ref) => {
    const { debounce } = useDebounce(delay);

    return (
      <div className="filters__form">
        <fieldset>
          <label htmlFor={id}>
            <input
              type="search"
              name={id}
              onChange={(e) => {
                const value = e.target.value;
                debounce(() => onChange(value));
              }}
              placeholder={placeholder}
              defaultValue={defaultValue}
              className="filters__input"
              autoComplete={autoComplete}
              spellCheck={spellCheck}
              ref={ref}
            />
          </label>
        </fieldset>
      </div>
    );
  }
);
